"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletSDKRelayEventManager = void 0;

var util_1 = require("../util");

var WalletSDKRelayEventManager = /*#__PURE__*/function () {
  function WalletSDKRelayEventManager() {
    _classCallCheck(this, WalletSDKRelayEventManager);

    this._nextRequestId = 0;
    this.callbacks = new Map();
  }

  _createClass(WalletSDKRelayEventManager, [{
    key: "makeRequestId",
    value: function makeRequestId() {
      // max nextId == max int32 for compatibility with mobile
      this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
      var id = this._nextRequestId;
      var idStr = (0, util_1.prepend0x)(id.toString(16)); // unlikely that this will ever be an issue, but just to be safe

      var callback = this.callbacks.get(idStr);

      if (callback) {
        this.callbacks["delete"](idStr);
      }

      return id;
    }
  }]);

  return WalletSDKRelayEventManager;
}();

exports.WalletSDKRelayEventManager = WalletSDKRelayEventManager;